/* =============================================
 * PC ヘッダー メガメニュー
 * ホバーではなくクリックで開閉する。
 * - 項目をクリック：開く／もう一度クリックで閉じる（他の項目は閉じる）
 * - リンク・ボタン以外（メニュー内の余白を含む）をクリック・Esc：閉じる
 * ============================================= */
(() => {
  const header = document.querySelector('.custom-header--desktop');
  if (!header) return;
  const items = [...header.querySelectorAll('.custom-header-nav-listitem')]
    .filter((li) => li.querySelector(':scope > .custom-header-megamenu'));
  if (!items.length) return;

  const labelOf = (li) => li.querySelector(':scope > ._label');

  const close = (except) => {
    items.forEach((li) => {
      if (li === except) return;
      li.classList.remove('is-open');
      const label = labelOf(li);
      if (label) label.setAttribute('aria-expanded', 'false');
    });
  };

  const toggle = (li) => {
    const open = !li.classList.contains('is-open');
    close(li);
    li.classList.toggle('is-open', open);
    const label = labelOf(li);
    if (label) label.setAttribute('aria-expanded', String(open));
  };

  items.forEach((li) => {
    const label = labelOf(li);
    if (!label) return;
    label.setAttribute('role', 'button');
    label.setAttribute('tabindex', '0');
    label.setAttribute('aria-expanded', 'false');
    label.addEventListener('click', (e) => {
      e.preventDefault();
      toggle(li);
    });
    label.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        toggle(li);
      }
    });
  });

  // リンク・ボタン・項目名以外（メニュー内の余白を含む）のクリックで閉じる
  document.addEventListener('click', (e) => {
    if (!items.some((li) => li.classList.contains('is-open'))) return;
    if (e.target.closest('a, button, input, select, .custom-header-nav-listitem > ._label')) return;
    close();
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') close();
  });
})();
